import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axiosInstance from "../../../interceptors";
import { SEED_COHORTS } from "../seed-data";
import { SEED_TEMPLATES } from "../email-templates/seed-templates";

const emptyForm = { name: "", skill: "", role: "", location: "", minYears: "", maxYears: "" };

/* ── Cohort-specific candidate pools ── */
const CANDIDATE_POOLS = {
  "Senior React Engineers - Bangalore": [
    { id:"c200", candidateName:"Aarav Sharma", candidateEmail:"aarav.sharma@gmail.com", phone:"9876543201", currentRole:"Senior React Developer", company:"TCS Digital", totalYearsExperience:6, currentLocation:"Bengaluru" },
    { id:"c201", candidateName:"Priya Nair", candidateEmail:"priya.nair@gmail.com", phone:"8765432102", currentRole:"React Lead", company:"Flipkart", totalYearsExperience:7, currentLocation:"Bengaluru" },
    { id:"c204", candidateName:"Rohit Gupta", candidateEmail:"rohit.gupta@gmail.com", phone:"8877665501", currentRole:"Frontend Engineer", company:"Razorpay", totalYearsExperience:5, currentLocation:"Bengaluru" },
    { id:"c206", candidateName:"Karthik Menon", candidateEmail:"karthik.menon@gmail.com", phone:"9654321001", currentRole:"Senior UI Developer", company:"Infosys", totalYearsExperience:6, currentLocation:"Bengaluru" },
    { id:"c232", candidateName:"Akash Pandey", candidateEmail:"akash.pandey@gmail.com", phone:"8877223301", currentRole:"Full Stack (React)", company:"Startup", totalYearsExperience:5, currentLocation:"Bengaluru" },
    { id:"c234", candidateName:"Saurabh Thakur", candidateEmail:"saurabh.thakur@gmail.com", phone:"9654445501", currentRole:"React Developer", company:"Wipro", totalYearsExperience:5, currentLocation:"Bengaluru" },
    { id:"c203", candidateName:"Sneha Patil", candidateEmail:"sneha.patil@gmail.com", phone:"9988776601", currentRole:"React Developer", company:"Persistent", totalYearsExperience:5, currentLocation:"Pune" },
    { id:"c205", candidateName:"Ananya Iyer", candidateEmail:"ananya.iyer@gmail.com", phone:"7766554401", currentRole:"Frontend Architect", company:"Zoho", totalYearsExperience:8, currentLocation:"Chennai" },
  ],
  "Java Backend - Pan India": [
    { id:"c220", candidateName:"Suresh Kumar", candidateEmail:"suresh.kumar@gmail.com", phone:"9876001101", currentRole:"Java Developer", company:"Cognizant", totalYearsExperience:5, currentLocation:"Chennai" },
    { id:"c221", candidateName:"Lakshmi Sundaram", candidateEmail:"lakshmi.sundaram@gmail.com", phone:"8765112201", currentRole:"Spring Boot Engineer", company:"HCL", totalYearsExperience:6, currentLocation:"Bengaluru" },
    { id:"c222", candidateName:"Rajesh Patel", candidateEmail:"rajesh.patel@gmail.com", phone:"7654223301", currentRole:"Backend Developer", company:"Oracle", totalYearsExperience:7, currentLocation:"Noida" },
    { id:"c223", candidateName:"Deepa Hegde", candidateEmail:"deepa.hegde@gmail.com", phone:"9988334401", currentRole:"Java Architect", company:"Mindtree", totalYearsExperience:8, currentLocation:"Bengaluru" },
    { id:"c224", candidateName:"Amit Mishra", candidateEmail:"amit.mishra@gmail.com", phone:"8877445501", currentRole:"Microservices Dev", company:"TCS", totalYearsExperience:5, currentLocation:"Chennai" },
    { id:"c225", candidateName:"Nandini Bhat", candidateEmail:"nandini.bhat@gmail.com", phone:"7766556601", currentRole:"Java Backend Lead", company:"Infosys", totalYearsExperience:6, currentLocation:"Hyderabad" },
    { id:"c226", candidateName:"Prakash Rajan", candidateEmail:"prakash.rajan@gmail.com", phone:"9654667701", currentRole:"Senior Java Dev", company:"Wipro", totalYearsExperience:7, currentLocation:"Bengaluru" },
    { id:"c227", candidateName:"Shreya Das", candidateEmail:"shreya.das@gmail.com", phone:"8543778801", currentRole:"Spring Developer", company:"Capgemini", totalYearsExperience:4, currentLocation:"Kolkata" },
  ],
  "DevOps Pipeline Experts": [
    { id:"c214", candidateName:"Rahul Singh", candidateEmail:"rahul.singh@gmail.com", phone:"9876445501", currentRole:"DevOps Engineer", company:"Amazon", totalYearsExperience:4, currentLocation:"Gurugram" },
    { id:"c215", candidateName:"Neha Verma", candidateEmail:"neha.verma@gmail.com", phone:"8765556601", currentRole:"Cloud Engineer", company:"Microsoft", totalYearsExperience:3, currentLocation:"Mumbai" },
    { id:"c216", candidateName:"Aditya Deshmukh", candidateEmail:"aditya.deshmukh@gmail.com", phone:"7654667701", currentRole:"SRE", company:"Atlassian", totalYearsExperience:5, currentLocation:"Pune" },
    { id:"c217", candidateName:"Swati Kulkarni", candidateEmail:"swati.kulkarni@gmail.com", phone:"9988778801", currentRole:"DevOps Lead", company:"Walmart Labs", totalYearsExperience:6, currentLocation:"Bengaluru" },
    { id:"c218", candidateName:"Manish Tiwari", candidateEmail:"manish.tiwari@gmail.com", phone:"8877889901", currentRole:"Platform Engineer", company:"PhonePe", totalYearsExperience:3, currentLocation:"Noida" },
    { id:"c219", candidateName:"Ritu Saxena", candidateEmail:"ritu.saxena@gmail.com", phone:"7766990001", currentRole:"Cloud Architect", company:"Deloitte", totalYearsExperience:5, currentLocation:"Gurugram" },
  ],
  "Data Scientists - Hyderabad": [
    { id:"c208", candidateName:"Arjun Krishnan", candidateEmail:"arjun.krishnan@gmail.com", phone:"9876123401", currentRole:"Data Scientist", company:"Amazon", totalYearsExperience:5, currentLocation:"Bengaluru" },
    { id:"c209", candidateName:"Meera Joshi", candidateEmail:"meera.joshi@gmail.com", phone:"8765098701", currentRole:"ML Engineer", company:"Flipkart", totalYearsExperience:4, currentLocation:"Hyderabad" },
    { id:"c210", candidateName:"Siddharth Rao", candidateEmail:"siddharth.rao@gmail.com", phone:"7654987601", currentRole:"Senior Data Scientist", company:"Mu Sigma", totalYearsExperience:6, currentLocation:"Bengaluru" },
    { id:"c211", candidateName:"Pooja Agarwal", candidateEmail:"pooja.agarwal@gmail.com", phone:"9988112201", currentRole:"AI/ML Lead", company:"Analytics Vidhya", totalYearsExperience:5, currentLocation:"Mumbai" },
    { id:"c213", candidateName:"Kavya Pillai", candidateEmail:"kavya.pillai@gmail.com", phone:"7766334401", currentRole:"Data Engineer", company:"Fractal", totalYearsExperience:3, currentLocation:"Chennai" },
  ],
  "Cloud Architects - Senior": [
    { id:"c238", candidateName:"Venkatesh Subramaniam", candidateEmail:"venkatesh.subram@gmail.com", phone:"7654889901", currentRole:"Solutions Architect", company:"AWS", totalYearsExperience:12, currentLocation:"Mumbai" },
    { id:"c239", candidateName:"Sunita Naidu", candidateEmail:"sunita.naidu@gmail.com", phone:"9988990001", currentRole:"Cloud Director", company:"Google", totalYearsExperience:14, currentLocation:"Gurugram" },
    { id:"c240", candidateName:"Manoj Tripathi", candidateEmail:"manoj.tripathi@gmail.com", phone:"8877001101", currentRole:"Principal Architect", company:"Accenture", totalYearsExperience:10, currentLocation:"Mumbai" },
    { id:"c241", candidateName:"Aparna Deshpande", candidateEmail:"aparna.deshpande@gmail.com", phone:"7766112201", currentRole:"Cloud Strategy Lead", company:"TCS", totalYearsExperience:9, currentLocation:"Bengaluru" },
  ],
};

const MSG_STATUSES = {
  none: { label: "—", cls: "" },
  sent: { label: "Sent", cls: "bg-gray-100 text-gray-600" },
  delivered: { label: "Delivered", cls: "bg-blue-50 text-blue-600" },
  seen: { label: "Seen", cls: "bg-vf-tint text-vf-primary" },
  accepted: { label: "Accepted", cls: "bg-green-50 text-green-700" },
  rescheduled: { label: "Rescheduled", cls: "bg-amber-50 text-amber-700" },
  declined: { label: "Declined", cls: "bg-red-50 text-red-600" },
};

const Cohorts = () => {
  const navigate = useNavigate();
  const [cohorts, setCohorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [matches, setMatches] = useState({});
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [selected, setSelected] = useState({});
  const [msgStatus, setMsgStatus] = useState({}); // { candidateId: "sent"|"delivered"|... }
  const [sending, setSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(null); // { current, total }
  const [toast, setToast] = useState(null);
  const [previewModal, setPreviewModal] = useState(null); // { channel: "EMAIL"|"WHATSAPP" }
  const [previewTplId, setPreviewTplId] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  // Close menu on outside click
  useEffect(() => { if (!openMenuId) return; const cl = () => setOpenMenuId(null); document.addEventListener("click", cl); return () => document.removeEventListener("click", cl); }, [openMenuId]);

  // Mock message status per cohort
  const cohortMsgStatus = {
    "Senior React Engineers - Bangalore": { sent:8, delivered:6, seen:4, accepted:3, total:12 },
    "Java Backend - Pan India": { sent:5, delivered:3, seen:2, accepted:1, total:10 },
    "DevOps Pipeline Experts": { sent:0, delivered:0, seen:0, accepted:0, total:6 },
    "Data Scientists - Hyderabad": { sent:4, delivered:4, seen:3, accepted:2, total:5 },
    "Cloud Architects - Senior": { sent:3, delivered:2, seen:1, accepted:0, total:4 },
  };

  const getTagClass = (tag) => {
    const skills = ["React","Java","Python","Kubernetes","AWS","Docker","Node.js","TypeScript","Angular","Spring Boot","Machine Learning"];
    const roles = ["Senior Developer","Backend Developer","DevOps Engineer","Data Scientist","Frontend Developer","Full Stack","Solutions Architect"];
    const locs = ["Bengaluru","Mumbai","Hyderabad","Chennai","Delhi","Noida","Gurugram","Kolkata","Pune"];
    if (skills.some(s => tag.includes(s))) return { bg:"#EEF2FF", color:"#4338CA" };
    if (roles.some(r => tag.includes(r))) return { bg:"#E1F5EE", color:"#085041" };
    if (locs.some(l => tag.includes(l))) return { bg:"#E6F1FB", color:"#0C447C" };
    if (tag.includes("yr")) return { bg:"#FAEEDA", color:"#633806" };
    return { bg:"#EEF2FF", color:"#4338CA" };
  };

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 4000); };

  const load = async () => {
    setLoading(true);
    try {
      const stored = localStorage.getItem("ample_cohorts");
      if (stored) { setCohorts(JSON.parse(stored)); }
      else { localStorage.setItem("ample_cohorts", JSON.stringify(SEED_COHORTS)); setCohorts(SEED_COHORTS); }
    } catch (e) { setCohorts(SEED_COHORTS); }
    finally { setLoading(false); }
  };

  useEffect(() => { document.title = "Cohorts - Ample Hire"; load(); }, []);

  const create = async () => {
    if (!form.name.trim()) return;
    setSaving(true);
    const newCohort = { id: "coh" + Date.now(), name: form.name.trim(), filters: { skill: form.skill || null, role: form.role || null, location: form.location || null, minYears: form.minYears ? Number(form.minYears) : null, maxYears: form.maxYears ? Number(form.maxYears) : null }, createdAt: new Date().toISOString() };
    const updated = [newCohort, ...cohorts];
    setCohorts(updated);
    localStorage.setItem("ample_cohorts", JSON.stringify(updated));
    setForm(emptyForm); setShowForm(false); setSaving(false);
  };

  const remove = (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this cohort?")) return;
    const updated = cohorts.filter((c) => c.id !== id);
    setCohorts(updated);
    localStorage.setItem("ample_cohorts", JSON.stringify(updated));
    if (openId === id) setOpenId(null);
  };

  const openCohort = (id) => {
    if (openId === id) { setOpenId(null); return; }
    setOpenId(id);
    setSelected({});
    setMsgStatus({});
    if (!matches[id]) {
      setLoadingMatches(true);
      const cohort = cohorts.find(c => c.id === id);
      // Match to pre-built pool or generate from name
      const pool = CANDIDATE_POOLS[cohort?.name] || Object.values(CANDIDATE_POOLS)[Math.floor(Math.random() * Object.keys(CANDIDATE_POOLS).length)] || [];
      // Select all by default
      const sel = {};
      pool.forEach(c => { sel[c.id] = true; });
      setSelected(sel);
      setMatches(m => ({ ...m, [id]: pool }));
      setLoadingMatches(false);
    } else {
      // Reselect all
      const sel = {};
      (matches[id] || []).forEach(c => { sel[c.id] = true; });
      setSelected(sel);
    }
  };

  const toggleSelected = (cid) => setSelected(s => ({ ...s, [cid]: !s[cid] }));
  const selectedCount = Object.values(selected).filter(Boolean).length;
  const selectAll = (cohortId) => { const sel = {}; (matches[cohortId] || []).forEach(c => { sel[c.id] = true; }); setSelected(sel); };
  const unselectAll = () => setSelected({});

  /* ── Send simulation ── */
  const simulateSend = async (channel) => {
    const ids = Object.keys(selected).filter(k => selected[k]);
    if (ids.length === 0) return;
    if (!window.confirm(`Send ${channel === "EMAIL" ? "email" : "WhatsApp"} to ${ids.length} selected candidates?`)) return;

    setSending(true);
    setSendProgress({ current: 0, total: ids.length });

    for (let i = 0; i < ids.length; i++) {
      const cid = ids[i];
      await new Promise(r => setTimeout(r, 300));
      setSendProgress({ current: i + 1, total: ids.length });
      setMsgStatus(s => ({ ...s, [cid]: "sent" }));
    }

    // Simulate delivery progression
    setTimeout(() => {
      ids.forEach(cid => setMsgStatus(s => ({ ...s, [cid]: "delivered" })));
    }, 1500);

    setTimeout(() => {
      ids.forEach((cid, i) => {
        if (i < ids.length - 2) setMsgStatus(s => ({ ...s, [cid]: "seen" }));
      });
    }, 3000);

    setTimeout(() => {
      ids.forEach((cid, i) => {
        if (i < ids.length - 3) setMsgStatus(s => ({ ...s, [cid]: "accepted" }));
        else if (i === ids.length - 2) setMsgStatus(s => ({ ...s, [cid]: "rescheduled" }));
        else if (i === ids.length - 1) setMsgStatus(s => ({ ...s, [cid]: "declined" }));
      });
      setSending(false);
      setSendProgress(null);
      showToast(`Successfully sent to ${ids.length} candidates`);
    }, 5000);
  };

  /* ── Preview ── */
  const templates = (() => { try { return JSON.parse(localStorage.getItem("ample_templates") || "[]"); } catch { return SEED_TEMPLATES; } })();
  const getPreview = useCallback((tplId, candidate) => {
    const tpl = templates.find(t => t.id === tplId);
    if (!tpl) return { subject: "", body: "Select a template to preview" };
    let body = tpl.body || "";
    let subject = tpl.subject || "";
    const vars = { "{{candidateName}}": candidate?.candidateName || "Candidate", "{{candidateEmail}}": candidate?.candidateEmail || "email@example.com", "{{jobTitle}}": "Senior React Developer", "{{companyName}}": "Namah Consultant", "{{interviewDate}}": "2026-04-20", "{{interviewTime}}": "10:00 AM", "{{acceptUrl}}": "https://app.amplehire.com/invite/abc123", "{{interviewUrl}}": "https://app.amplehire.com/interview/xyz789" };
    Object.entries(vars).forEach(([k, v]) => { body = body.replaceAll(k, v); subject = subject.replaceAll(k, v); });
    return { subject, body };
  }, [templates]);

  const renderFilters = (f) => {
    if (!f) return null;
    const chips = [];
    if (f.skill) chips.push(f.skill);
    if (f.role) chips.push(f.role);
    if (f.location) chips.push(f.location);
    if (f.minYears != null || f.maxYears != null) chips.push(`${f.minYears ?? 0}–${f.maxYears ?? "?"} yrs`);
    if (chips.length === 0) chips.push("no filters");
    return chips.map((c, i) => <span key={i} className="badge-brand">{c}</span>);
  };

  const statusBadge = (cid) => {
    const st = msgStatus[cid] || "none";
    const s = MSG_STATUSES[st] || MSG_STATUSES.none;
    if (st === "none") return <span className="text-xs text-gray-300">—</span>;
    return (
      <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${s.cls}`} style={{ transition: "all 0.3s ease" }}>
        {st === "sent" && <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse" />}
        {st === "accepted" && <span>&#10003;</span>}
        {s.label}
      </span>
    );
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-vf-base">Cohorts</h1>
          <p className="text-sm mt-1 text-vf-muted">Saved candidate filters. Open any cohort to view, select, and message candidates.</p>
        </div>
        <button onClick={() => setShowForm(s => !s)} className="btn-primary btn-sm">{showForm ? "Cancel" : "+ New cohort"}</button>
      </div>

      {/* Create Form */}
      {showForm && (
        <div className="card p-5 space-y-3">
          <h2 className="text-sm font-semibold text-vf-base">New cohort</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div><label className="input-label">Cohort name</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Senior React — Bangalore" /></div>
            <div><label className="input-label">Skill</label><input className="input" value={form.skill} onChange={e => setForm({ ...form, skill: e.target.value })} placeholder="react" /></div>
            <div><label className="input-label">Role</label><input className="input" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} placeholder="frontend engineer" /></div>
            <div><label className="input-label">Location</label><input className="input" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} placeholder="Bangalore" /></div>
            <div><label className="input-label">Min years</label><input className="input" type="number" value={form.minYears} onChange={e => setForm({ ...form, minYears: e.target.value })} placeholder="3" /></div>
            <div><label className="input-label">Max years</label><input className="input" type="number" value={form.maxYears} onChange={e => setForm({ ...form, maxYears: e.target.value })} placeholder="8" /></div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button onClick={() => { setShowForm(false); setForm(emptyForm); }} className="btn-ghost btn-sm">Cancel</button>
            <button onClick={create} disabled={saving || !form.name.trim()} className="btn-primary btn-sm">{saving ? "Saving..." : "Save cohort"}</button>
          </div>
        </div>
      )}

      {/* Cohort List */}
      {loading ? (
        <div className="card p-10 text-center"><div className="skeleton h-4 w-24 mx-auto rounded" /></div>
      ) : cohorts.length === 0 ? (
        <div className="card p-10 text-center"><p className="text-sm text-vf-muted">No cohorts yet.</p></div>
      ) : (
        <div className="space-y-4">
          {cohorts.map(c => {
            const ms = cohortMsgStatus[c.name] || { sent:0, delivered:0, seen:0, accepted:0, total: c.candidateCount || (matches[c.id]||[]).length || 0 };
            const msTotal = Math.max(ms.sent + ms.delivered + ms.seen + ms.accepted, 1);
            const hasSent = ms.sent + ms.delivered + ms.seen + ms.accepted > 0;
            const filterChips = [];
            if (c.filters?.skill) filterChips.push(c.filters.skill);
            if (c.filters?.role) filterChips.push(c.filters.role);
            if (c.filters?.location) filterChips.push(c.filters.location);
            if (c.filters?.minYears != null || c.filters?.maxYears != null) filterChips.push(`${c.filters.minYears ?? 0}–${c.filters.maxYears ?? "?"}  yrs`);

            return (
            <div key={c.id} style={{ background:"white", border:"1px solid #E2E8F0", borderRadius:12, position:"relative", overflow:"hidden", transition:"border-color 0.2s" }}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#CBD5E1"} onMouseLeave={e=>e.currentTarget.style.borderColor="#E2E8F0"}>
              <div style={{ padding:"16px 20px" }}>
                {/* HEADER */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                  <div style={{ flex:1, minWidth:0 }}>
                    <h3 style={{ fontSize:15, fontWeight:600, color:"#0F172A", margin:"0 0 2px" }}>{c.name}</h3>
                    <p style={{ fontSize:11, color:"#64748B", margin:0 }}>{ms.total || c.candidateCount || "?"} matching candidates</p>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ fontSize:10, padding:"2px 10px", borderRadius:100, background:"#EEF2FF", color:"#4338CA", fontWeight:500 }}>{ms.total || c.candidateCount || 0} candidates</span>
                    <div style={{ position:"relative" }}>
                      <button onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId===c.id?null:c.id); }}
                        style={{ background:"none", border:"none", cursor:"pointer", color:"#94A3B8", fontSize:20, padding:"2px 4px", borderRadius:4, lineHeight:1 }}>&#8942;</button>
                      {openMenuId === c.id && (
                        <div onClick={e=>e.stopPropagation()} style={{ position:"absolute", right:0, top:28, background:"white", border:"1px solid #E2E8F0", borderRadius:8, padding:4, zIndex:50, minWidth:155, boxShadow:"0 4px 16px rgba(0,0,0,0.1)" }}>
                          <button style={{ display:"block", width:"100%", textAlign:"left", padding:"7px 12px", fontSize:12, border:"none", background:"none", cursor:"pointer", borderRadius:4, color:"#334155" }}
                            onMouseEnter={e=>e.target.style.background="#F8FAFC"} onMouseLeave={e=>e.target.style.background="none"}
                            onClick={()=>setOpenMenuId(null)}>Edit filters</button>
                          <button style={{ display:"block", width:"100%", textAlign:"left", padding:"7px 12px", fontSize:12, border:"none", background:"none", cursor:"pointer", borderRadius:4, color:"#334155" }}
                            onMouseEnter={e=>e.target.style.background="#F8FAFC"} onMouseLeave={e=>e.target.style.background="none"}
                            onClick={()=>{showToast("Cohort duplicated (demo)");setOpenMenuId(null);}}>Duplicate cohort</button>
                          <div style={{ height:1, background:"#F1F5F9", margin:"4px 0" }} />
                          <button onClick={e=>{remove(c.id,e);setOpenMenuId(null);}}
                            style={{ display:"block", width:"100%", textAlign:"left", padding:"7px 12px", fontSize:12, border:"none", background:"none", cursor:"pointer", borderRadius:4, color:"#DC2626" }}
                            onMouseEnter={e=>e.target.style.background="#FEF2F2"} onMouseLeave={e=>e.target.style.background="none"}>Delete cohort</button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* FILTER TAGS */}
                <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom:10 }}>
                  {filterChips.length > 0 ? filterChips.map((tag, i) => {
                    const tc = getTagClass(tag);
                    return <span key={i} style={{ fontSize:10, padding:"2px 8px", borderRadius:100, fontWeight:500, background:tc.bg, color:tc.color }}>{tag}</span>;
                  }) : <span style={{ fontSize:10, color:"#94A3B8" }}>No filters</span>}
                </div>

                {/* MESSAGE STATUS BAR */}
                {hasSent ? (
                  <>
                    <div style={{ height:4, borderRadius:2, background:"#F1F5F9", display:"flex", overflow:"hidden", marginBottom:4 }}>
                      {ms.sent > 0 && <div style={{ width:`${(ms.sent/msTotal)*100}%`, height:"100%", background:"#CBD5E1" }} />}
                      {ms.delivered > 0 && <div style={{ width:`${(ms.delivered/msTotal)*100}%`, height:"100%", background:"#3B82F6" }} />}
                      {ms.seen > 0 && <div style={{ width:`${(ms.seen/msTotal)*100}%`, height:"100%", background:"#7B5AC4" }} />}
                      {ms.accepted > 0 && <div style={{ width:`${(ms.accepted/msTotal)*100}%`, height:"100%", background:"#10B981" }} />}
                    </div>
                    <div style={{ fontSize:9, color:"#64748B", marginBottom:10 }}>
                      <strong style={{ color:"#0F172A" }}>{ms.sent}</strong> sent &middot; <strong style={{ color:"#0F172A" }}>{ms.delivered}</strong> delivered &middot; <strong style={{ color:"#0F172A" }}>{ms.accepted}</strong> accepted
                    </div>
                  </>
                ) : (
                  <div style={{ fontSize:10, color:"#94A3B8", marginBottom:10, fontStyle:"italic" }}>No invites sent yet</div>
                )}

                {/* ACTION BUTTONS */}
                <div style={{ display:"flex", gap:6, marginBottom:8 }}>
                  <button onClick={() => openCohort(c.id)}
                    style={{ fontSize:11, padding:"6px 14px", borderRadius:8, border:"1px solid #C7D2FE", background:"#EEF2FF", cursor:"pointer", color:"#4338CA", fontWeight:600 }}>
                    {openId === c.id ? "Close cohort" : "Open cohort"}
                  </button>
                  <button onClick={() => { openCohort(c.id); }}
                    style={{ fontSize:11, padding:"6px 14px", borderRadius:8, border:"1px solid #E2E8F0", background:"white", cursor:"pointer", color:"#64748B", fontWeight:500 }}>
                    Send invites
                  </button>
                </div>

                {/* ACTIVITY META */}
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:10, color:"#94A3B8", paddingTop:8, borderTop:"1px solid #F1F5F9" }}>
                  <span>Created {c.createdAt ? new Date(c.createdAt).toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" }) : "recently"}</span>
                  <span>{hasSent ? "Last sent: 2h ago" : "Never sent"}</span>
                </div>
              </div>

              {/* ═══════ EXPANDED COHORT VIEW ═══════ */}
              {openId === c.id && (
                <div className="border-t" style={{ borderColor: "rgba(99,102,241,0.12)" }}>
                  {loadingMatches && !matches[c.id] ? (
                    <div className="text-center py-8"><div className="skeleton h-4 w-32 mx-auto rounded" /></div>
                  ) : (matches[c.id] || []).length === 0 ? (
                    <div className="text-center text-sm py-8 text-vf-muted">No candidates match this filter.</div>
                  ) : (
                    <>
                      {/* Action Bar */}
                      <div className="px-5 py-3 bg-gray-50 flex flex-wrap items-center gap-3" style={{ borderBottom: "1px solid rgba(99,102,241,0.08)" }}>
                        <label className="flex items-center gap-2 text-xs font-medium text-vf-base cursor-pointer">
                          <input type="checkbox" checked={selectedCount === (matches[c.id] || []).length && selectedCount > 0} onChange={() => selectedCount === (matches[c.id] || []).length ? unselectAll() : selectAll(c.id)} style={{ accentColor: "#7B5AC4" }} />
                          {selectedCount}/{(matches[c.id] || []).length} selected
                        </label>
                        <span className="text-gray-300">|</span>
                        <button onClick={() => simulateSend("EMAIL")} disabled={selectedCount === 0 || sending} className="btn-sm text-xs font-semibold text-white rounded-lg px-3 py-1.5" style={{ background: selectedCount > 0 && !sending ? "#7B5AC4" : "#CBD5E1", cursor: selectedCount > 0 && !sending ? "pointer" : "not-allowed" }}>
                          &#9993; Send Email Invite
                        </button>
                        <button onClick={() => simulateSend("WHATSAPP")} disabled={selectedCount === 0 || sending} className="btn-sm text-xs font-semibold text-white rounded-lg px-3 py-1.5" style={{ background: selectedCount > 0 && !sending ? "#25D366" : "#CBD5E1", cursor: selectedCount > 0 && !sending ? "pointer" : "not-allowed" }}>
                          &#128172; Send WhatsApp
                        </button>
                        <button onClick={() => { setPreviewTplId(""); setPreviewModal({ channel: "EMAIL" }); }} className="btn-ghost btn-sm text-xs">Preview Email</button>
                        <button onClick={() => { setPreviewTplId(""); setPreviewModal({ channel: "WHATSAPP" }); }} className="btn-ghost btn-sm text-xs">Preview WhatsApp</button>
                        {sendProgress && (
                          <span className="text-xs text-vf-primary font-medium animate-pulse ml-auto">
                            Sending... {sendProgress.current}/{sendProgress.total}
                          </span>
                        )}
                      </div>

                      {/* Candidate Table */}
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm">
                          <thead>
                            <tr style={{ background: "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}>
                              <th className="px-3 py-2.5 w-8"></th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Phone</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Exp</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Company</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Location</th>
                              <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wider">Message</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(matches[c.id] || []).map(r => (
                              <tr key={r.id} className="hover:bg-vf-tint/30" style={{ borderBottom: "1px solid #F1F5F9", transition: "background 0.15s" }}>
                                <td className="px-3 py-2.5">
                                  <input type="checkbox" checked={!!selected[r.id]} onChange={() => toggleSelected(r.id)} style={{ accentColor: "#7B5AC4" }} />
                                </td>
                                <td className="px-3 py-2.5 font-medium text-gray-900">{r.candidateName}</td>
                                <td className="px-3 py-2.5 text-gray-500 text-xs">{r.candidateEmail}</td>
                                <td className="px-3 py-2.5 text-gray-500 text-xs">{r.phone || "—"}</td>
                                <td className="px-3 py-2.5 text-gray-500">{r.totalYearsExperience}y</td>
                                <td className="px-3 py-2.5 text-gray-500 text-xs">{r.company || "—"}</td>
                                <td className="px-3 py-2.5 text-gray-500 text-xs">{r.currentLocation}</td>
                                <td className="px-3 py-2.5">{statusBadge(r.id)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
            );
          })}
        </div>
      )}

      {/* ═══════ PREVIEW MODAL ═══════ */}
      {previewModal && (() => {
        const ch = previewModal.channel;
        const tpls = templates.filter(t => t.channel === ch);
        const firstCandidate = openId ? (matches[openId] || [])[0] : null;
        const preview = getPreview(previewTplId, firstCandidate);
        const isWhatsApp = ch === "WHATSAPP";

        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: "rgba(0,0,0,0.4)", backdropFilter: "blur(4px)" }} onClick={() => setPreviewModal(null)}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden" onClick={e => e.stopPropagation()}>
              {/* Modal Header */}
              <div className="px-6 py-4 flex items-center justify-between" style={{ borderBottom: "1px solid #E2E8F0" }}>
                <h3 className="font-semibold text-gray-900">{isWhatsApp ? "WhatsApp" : "Email"} Preview</h3>
                <button onClick={() => setPreviewModal(null)} className="text-gray-400 hover:text-gray-600 text-xl">&times;</button>
              </div>

              <div className="p-6 space-y-4">
                {/* Template Selector */}
                <div>
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1 block">Template</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm" value={previewTplId} onChange={e => setPreviewTplId(e.target.value)} style={{ borderColor: "#E2E8F0" }}>
                    <option value="">Select a template...</option>
                    {tpls.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                  </select>
                </div>

                {/* Preview Content */}
                {previewTplId && (
                  isWhatsApp ? (
                    <div className="mx-auto" style={{ maxWidth: 320 }}>
                      <div style={{ background: "#075E54", color: "white", padding: "10px 16px", borderRadius: "16px 16px 0 0", fontSize: 13, fontWeight: 600 }}>
                        &#128172; WhatsApp Business
                      </div>
                      <div style={{ background: "#ECE5DD", padding: 16, borderRadius: "0 0 16px 16px", minHeight: 200 }}>
                        <div style={{ background: "white", borderRadius: 12, padding: "10px 14px", fontSize: 13, lineHeight: 1.6, whiteSpace: "pre-wrap", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>
                          {preview.body.replace(/<[^>]*>/g, "")}
                        </div>
                        <div style={{ textAlign: "right", fontSize: 10, color: "#667781", marginTop: 4 }}>10:30 AM &#10003;&#10003;</div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ border: "1px solid #E2E8F0", borderRadius: 12, overflow: "hidden" }}>
                      <div style={{ background: "#F8FAFC", padding: "8px 16px", borderBottom: "1px solid #E2E8F0", display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#EF4444" }} />
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#F59E0B" }} />
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#10B981" }} />
                        <span style={{ marginLeft: 8, fontSize: 11, color: "#94A3B8" }}>Email Preview</span>
                      </div>
                      <div style={{ padding: 20 }}>
                        <div style={{ fontSize: 11, color: "#94A3B8", marginBottom: 8 }}>
                          Subject: <strong style={{ color: "#1E293B" }}>{preview.subject || "(no subject)"}</strong>
                        </div>
                        <div style={{ borderTop: "1px solid #F1F5F9", paddingTop: 12, fontSize: 13, lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: preview.body }} />
                      </div>
                    </div>
                  )
                )}
              </div>

              {/* Modal Footer */}
              <div className="px-6 py-4 flex items-center justify-end gap-2" style={{ borderTop: "1px solid #E2E8F0", background: "#F8FAFC" }}>
                <button onClick={() => setPreviewModal(null)} className="btn-ghost btn-sm">Close</button>
                <button
                  onClick={() => { setPreviewModal(null); simulateSend(ch); }}
                  disabled={selectedCount === 0}
                  className="btn-sm text-xs font-semibold text-white rounded-lg px-4 py-2"
                  style={{ background: isWhatsApp ? "#25D366" : "#7B5AC4" }}
                >
                  Send to Selected ({selectedCount})
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Toast */}
      {toast && (
        <div className="fixed bottom-6 right-6 z-50 bg-white rounded-xl shadow-xl border px-5 py-3 text-sm font-medium text-gray-800" style={{ borderColor: "#E2E8F0", animation: "fadeIn 0.3s ease" }}>
          &#10003; {toast}
        </div>
      )}
    </div>
  );
};

export default Cohorts;
